// Get Shopify Status
export const GET_SHOPIFY_STATUS_REQUEST = 'GET_SHOPIFY_STATUS_REQUEST';
export const GET_SHOPIFY_STATUS_DONE = 'GET_SHOPIFY_STATUS_DONE';
export const GET_SHOPIFY_STATUS_FAILED = 'GET_SHOPIFY_STATUS_FAILED';
